import {
  useGetOrganizationsQuery,
  useGetUserQuery,
} from "~@/graphql/codegen/generated";

const useInternalUser = (
  baseOptions?: Parameters<typeof useGetUserQuery>[0]
) => {
  const { data, loading, error, startPolling, stopPolling } = useGetUserQuery({
    ...baseOptions,
  });
  const { data: organizationsData } = useGetOrganizationsQuery();

  return {
    internalUser: data?.getUser,
    isInternalUserLoading: loading,
    internalUserError: error,
    startPolling,
    stopPolling,
    isRoot:
      data?.getUser?.isRoot ||
      !organizationsData?.getOrganizations?.current?.parentOID,
  } as const;
};

export default useInternalUser;
